webpackJsonp([70144966829960],{

/***/ 63:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIframe = __webpack_require__(52);
	
	var _reactIframe2 = _interopRequireDefault(_reactIframe);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (_ref) {
	        var width = _ref.width,
	            height = _ref.height,
	            src = _ref.src;
	        return _react2.default.createElement(_reactIframe2.default, {
	                width: width,
	                height: height,
	                url: src,
	                display: 'initial',
	                position: 'relative',
	                allowFullScreen: true });
	};
	
	module.exports = exports['default'];

/***/ }),

/***/ 195:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"AddressBock":"src-layouts----Pages-module---AddressBock---1KhHS","Address":"src-layouts----Pages-module---Address---KDR6o","Cancellation":"src-layouts----Pages-module---Cancellation---ry8Zz","CancellationItem":"src-layouts----Pages-module---CancellationItem---2tIaP","AddressBockMap":"src-layouts----Pages-module---AddressBockMap---2XvyW"};

/***/ }),

/***/ 324:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(2);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _Footer = __webpack_require__(78);
	
	var _Footer2 = _interopRequireDefault(_Footer);
	
	var _Iframe = __webpack_require__(63);
	
	var _Iframe2 = _interopRequireDefault(_Iframe);
	
	var _reactHelmet = __webpack_require__(15);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _PagesModule = __webpack_require__(195);
	
	var _PagesModule2 = _interopRequireDefault(_PagesModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _class = function (_Component) {
	    _inherits(_class, _Component);
	
	    function _class() {
	        _classCallCheck(this, _class);
	
	        return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	    }
	
	    _class.prototype.render = function render() {
	        var deviceWidth = this.props.gDeviceWidth;
	
	        return _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	                _reactHelmet2.default,
	                null,
	                _react2.default.createElement('html', { lang: 'fr' }),
	                _react2.default.createElement(
	                    'title',
	                    null,
	                    'Contactez nous au 613-252-5227 ou prenez un rendez-vous en ligne.'
	                ),
	                _react2.default.createElement('meta', { name: 'description', content: 'Nous sommes ouver du Lundi au Vendredi de 9AM \xE0 12PM et de 1PM \xE0 5PM. N\'\xE9sitez pas \xE0 nous contactez pour prendre un rendez-vous ou pour plus d\'information. ' })
	            ),
	            _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                    'div',
	                    { style: { maxWidth: 1170, padding: '20px', margin: 'auto' } },
	                    _react2.default.createElement(
	                        'div',
	                        { className: _PagesModule2.default.Address },
	                        _react2.default.createElement(
	                            'div',
	                            { className: _PagesModule2.default.AddressBock, style: { display: 'flex', alignItems: 'center', padding: 0 } },
	                            _react2.default.createElement(
	                                'div',
	                                null,
	                                _react2.default.createElement(
	                                    'h1',
	                                    null,
	                                    'Nous joindre'
	                                ),
	                                _react2.default.createElement(
	                                    'p',
	                                    null,
	                                    _react2.default.createElement(
	                                        'strong',
	                                        null,
	                                        'CPM: Centre de Psychotromatology et Mediation'
	                                    ),
	                                    _react2.default.createElement('br', null),
	                                    _react2.default.createElement(
	                                        'span',
	                                        { style: { color: '#1689DF' } },
	                                        'Lundi - Vendredi: 9AM - 12PM & 1PM - 5PM'
	                                    ),
	                                    _react2.default.createElement('br', null),
	                                    '427 McArthur Ave, 2e Etage, Suite #3',
	                                    _react2.default.createElement('br', null),
	                                    'Ottawa (ON) K1K 1G5, Canada',
	                                    _react2.default.createElement('br', null),
	                                    'T\xE9l. ',
	                                    _react2.default.createElement(
	                                        'a',
	                                        { href: 'tel:+16132525227' },
	                                        '+1 (613) 252-5227'
	                                    ),
	                                    _react2.default.createElement('br', null),
	                                    'E-mail: ',
	                                    _react2.default.createElement(
	                                        'a',
	                                        { href: 'mailto:info@cpm-ca.org' },
	                                        'info@cpm-ca.org'
	                                    ),
	                                    _react2.default.createElement('br', null),
	                                    _react2.default.createElement(
	                                        _gatsbyLink2.default,
	                                        { to: '/reservation' },
	                                        _react2.default.createElement(
	                                            'em',
	                                            null,
	                                            _react2.default.createElement(
	                                                'strong',
	                                                null,
	                                                'ou Prenez rendez-vous en ligne'
	                                            )
	                                        )
	                                    )
	                                )
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { className: _PagesModule2.default.AddressBockMap },
	                            _react2.default.createElement(
	                                'div',
	                                null,
	                                _react2.default.createElement(_Iframe2.default, { width: '100%', height: '' + (deviceWidth > 767 ? "400px" : '300px'), src: 'https://www.google.com/maps/embed/v1/place?key=AIzaSyD5d58sVD8JymoPG0mWxmQP8glK9_m9cI4&q=427+McArthur+Ave,Ottawa,ON' })
	                            )
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: _PagesModule2.default.Cancellation },
	                        _react2.default.createElement(
	                            'div',
	                            { className: _PagesModule2.default.CancellationItem },
	                            _react2.default.createElement(
	                                'h2',
	                                null,
	                                'Annuler un rendez-vous'
	                            ),
	                            _react2.default.createElement(
	                                'p',
	                                null,
	                                'Si vous annulez ou d\xE9placez votre premier rendez-vous avec un pr\xE9avis de moins de 48 heures, ou si vous ne vous pr\xE9sentez pas, vous serez factur\xE9 le montant total de la consultation.'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { className: _PagesModule2.default.CancellationItem },
	                            _react2.default.createElement(
	                                'h2',
	                                null,
	                                'Remboursement'
	                            ),
	                            _react2.default.createElement(
	                                'p',
	                                null,
	                                'Toutes nos consultations peuvent \xEAtre partiellement ou totallement rembours\xE9es par certaines assurances. Pour plus d\'information veuillez prendre contact avec le secr\xE9tariat.'
	                            )
	                        )
	                    )
	                )
	            ),
	            _react2.default.createElement(_Footer2.default, null)
	        );
	    };
	
	    return _class;
	}(_react.Component);
	
	exports.default = _class;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-contact-js-4d6a20de6f27ca3b2dc2.js